/* eslint-disable arrow-body-style */

import React from 'react';
import { TableColumn } from 'tea-component';
import { CommonColumnBuilders } from '@gp/utils/columns';
import { getIsDisabled, resetEditorContent } from '../../../../utils';
import { buildProjectColumn } from '../../../../utils/columns';
import { SMALL_WIDTH_COLUMN_WIDTH, LARGE_WIDTH_COLUMN_WIDTH } from '../../../../constants';
import { BoolFlag } from '@gp/enums/common';

import type { IDPSReportCalendarProjectSimpleVO } from '@gp/types/dpsReport/common';
import type { IDPSReportProjectCommentsUpdatesVO } from '@gp/types/dpsReport/v3';

import DEFAULT_GAME_ICON from '@/pages/dashboard/assets/svg/mobile-game-default.svg';

const ProjectColumn = buildProjectColumn<IDPSReportProjectCommentsUpdatesVO>({
  header: 'Project',
  width: SMALL_WIDTH_COLUMN_WIDTH,
});

export const getColumnsEditable = (props: {
  projects?: IDPSReportCalendarProjectSimpleVO[] | null;
  records: IDPSReportProjectCommentsUpdatesVO[];
  setRecords: React.Dispatch<React.SetStateAction<IDPSReportProjectCommentsUpdatesVO[]>>;
  onChange?: (payload: any[]) => void;
}) => {
  const { projects, records, setRecords, onChange } = props;

  const projectsOptions = projects?.map((item) => {
    const { project_id: projectId, project } = item || {};
    return {
      text: project || '',
      value: projectId || '',
    };
  });

  return [
    CommonColumnBuilders.buildCustomizeSelectColumn<IDPSReportProjectCommentsUpdatesVO>({
      key: 'project_id',
      className: 'dbg-dps-report-customize-select',
      header: 'Project',
      width: SMALL_WIDTH_COLUMN_WIDTH,
      button: (cvm) => cvm?.project,
      placeholder: 'None',
      customizePlaceholder: 'Please input other',
      options: projectsOptions || [],
      onChange: (cvm, key, payload, rowKey, rowIndex) => {
        const { mock_id: mockId } = cvm || {};
        const project = projects?.find((item) => item?.project_id === payload);
        const { project: projectName, platform, image_name: imageName, cover, priority } = project || {};
        const isCustom = !project;
        const recordIdx = records.findIndex((item) => item?.mock_id === mockId);
        const recordTmp = {
          ...records[recordIdx],
          project_id: payload || '',
          project: (isCustom ? payload : projectName) || '',
          platform: (isCustom ? [] : platform) || [],
          image_name: (isCustom ? '' : imageName) || '',
          cover: (isCustom ? '' : cover) || '',
          priority: (isCustom ? '' : priority) || '',
          comment: '',
          is_custom: isCustom ? BoolFlag.True : BoolFlag.False,
        };
        const recordsTmp = [...records.slice(0, recordIdx), recordTmp, ...records.slice(recordIdx + 1)];
        const rootNode = document.querySelector('.dbg-dps-report-project-comments-updates-table');
        resetEditorContent(rootNode, rowIndex);
        setRecords(recordsTmp);
        onChange?.(recordsTmp);
      },
    }),
    CommonColumnBuilders.buildEditorColumn<IDPSReportProjectCommentsUpdatesVO>({
      key: 'comment',
      header: 'Comments/Updates',
      width: LARGE_WIDTH_COLUMN_WIDTH,
      placeholder: 'Please input Comments/Updates',
      minHeight: 120,
      getIsDisabled: (cvm) => getIsDisabled(cvm),
      onChange: (cvm, key, payload) => {
        const { mock_id: mockId } = cvm || {};
        const recordIdx = records.findIndex((item) => item?.mock_id === mockId);
        const recordTmp = {
          ...records[recordIdx],
          comment: payload || '',
        };
        const recordsTmp = [...records.slice(0, recordIdx), recordTmp, ...records.slice(recordIdx + 1)];
        setRecords(recordsTmp);
        onChange?.(recordsTmp);
      },
    }),
  ];
};

export const getColumnsReadonly = (): TableColumn<IDPSReportProjectCommentsUpdatesVO>[] => {
  return [
    {
      ...ProjectColumn,
      render: (cvm, ...restParams) => {
        const { is_custom: isCustom = BoolFlag.True, project } = cvm || {};
        // 不是自定义project，则按照gpop系统通用project形式渲染
        // @ts-ignore
        if (isCustom === BoolFlag.False) return ProjectColumn?.render(cvm, ...restParams);
        return (
          <div className="dbg-customize-project-item">
            <img className="dbg-customize-project-item__img" src={DEFAULT_GAME_ICON} />
            <span className="dbg-customize-project-item__text">{project || '-'}</span>
          </div>
        );
      },
    },
    CommonColumnBuilders.buildRichTextColumn({
      key: 'comment',
      header: 'Comments/Updates',
      width: LARGE_WIDTH_COLUMN_WIDTH,
    }),
  ];
};
